module.exports = "<app-header (featureSelected)=\"onNavigate($event)\"></app-header>\n<div>\n  <router-outlet></router-outlet>\n</div>"